import { computed } from 'vue';
import { NetworkProfile as NetworkProfileApi, searchNetworkProfiles } from '@infuse/api/e-connector/network-profile';
import { mapToDomain } from '@infuse/e-connector/network-profile/domain';
import { usePageableResource } from '@infuse/e-connector/shared/queries';

export const useNetworkProfiles = (pageSize = 20) => {
  const SEARCHABLE_FIELDS = ['name'];

  const query = usePageableResource<NetworkProfileApi>(searchNetworkProfiles, {
    queryKey: 'network-profiles',
    searchableFields: SEARCHABLE_FIELDS,
    pageSize
  });

  const networkProfiles = computed(
    () => query.data.value?.pages.flatMap((page) => page.content?.map((np) => mapToDomain(np))) || []
  );

  return {
    ...query,
    networkProfiles
  };
};
